import React from 'react';
import { XIcon } from 'lucide-react';
import { Section, Reveal } from './Section';
const problems = ['Mentorías privadas que arrancan en $500 USD — impagables cuando recién empezás.', 'Gurús de señales que prometen ganancias rápidas, sin ningún fundamento detrás.', 'Contenido gratuito disperso: mil videos sueltos y ningún camino ordenado.', 'Miedo a operar sin saber gestionar el riesgo de tu propio capital.', 'Ningún camino accesible que te tome en serio como principiante.'];
export function ProblemSection() {
  return <Section className="bg-ink-950" data-id="element-190" data-mp="35fiubws0bzb7">
      <Reveal data-id="element-191" data-mp="35in6phfmm1cy">
        <h2 className="font-display text-2xl font-bold leading-tight tracking-tight text-white sm:text-3xl lg:text-4xl" data-id="element-192" data-mp="3jg23x8c4fdfh">
          ¿Cuántos meses más vas a postergar entrar en serio al mundo de las
          inversiones?
        </h2>
        <p className="mt-4 text-base text-gray-400 sm:text-lg" data-id="element-193" data-mp="1p33t8nmieerm">
          Lo pensás hace tiempo. Investigaste. Y te chocaste con esto:
        </p>
      </Reveal>

      <ul className="mt-8 space-y-3" data-id="element-194" data-mp="jd3pitjhulu2">
        {problems.map((p, i) => <Reveal key={p} delay={i * 0.06} data-id="element-195" data-mp="jey9o5mxy9x3" data-mpi={i}>
            <li className="flex items-start gap-3 rounded-xl border border-white/5 bg-ink-900 p-4" data-id="element-196" data-mp="obydsb08d2lk">
              <span className="mt-0.5 flex h-6 w-6 flex-none items-center justify-center rounded-full bg-red-500/10" data-id="element-197" data-mp="se1qf2ymyd8f">
                <XIcon className="h-4 w-4 text-red-400" data-id="element-198" data-mp="x4s18vptz8ai" />
              </span>
              <span className="text-sm text-gray-300 sm:text-base" data-id="element-199" data-mp="123v203ys2sco">{p}</span>
            </li>
          </Reveal>)}
      </ul>

      <Reveal delay={0.1} data-id="element-200" data-mp="171mvh2f2mmiz">
        <p className="mt-8 border-l-2 border-brand pl-5 text-base font-medium leading-relaxed text-gray-200 sm:text-lg" data-id="element-201" data-mp="1714szo1tfc2m">
          Vos no buscás hacerte rico de un día para el otro. Buscás empezar bien,
          con método, sabiendo que esto se construye con el tiempo.
        </p>
      </Reveal>
    </Section>;
}